// extracted by mini-css-extract-plugin
export default {"speakerDetail":"speakerDetail__A5hARR"};